import { endPoints } from '@fixed/endPoints';
import { logMessages } from '@fixed/logMessages';
import axios from 'axios';
import { CToast } from '../../../views/addons/ToastMessage';
import { getUserData } from '../../Utils';
import { prepareUrl } from './helpers/prepareUrl';

const CancelToken = axios.CancelToken;
let cancel;
let log;

const saveLog = async (endPoint, log, method, token) => {
  return await axios(
    `${process.env.REACT_APP_HOST_URI}${endPoints[endPoint]}`,
    {
      method: 'POST',
      headers: { 'Content-type': 'application/json', 'x-token': token },
      data: { message: log, userId: getUserData()?.id, method },
    },
  );
};

const prepareRequestConfig = async (
  endPoint,
  params,
  id,
  method,
  strict,
  headers = { 'Content-type': 'application/json' },
) => {
  const token = localStorage.getItem('accessToken');
  headers['x-token'] = token;
  const requestConfig = {
    responseType: params?.responseType || 'text',
    method,
    headers,
  };
  const multiParams = new URLSearchParams();
  const isMultiParams = params && params instanceof Array;
  if (isMultiParams) params.forEach((f) => multiParams.append('filter', f));
  switch (method) {
    case 'GET':
      requestConfig['params'] = isMultiParams ? multiParams : params;
      break;
    case 'POST':
    case 'PUT':
      requestConfig['method'] =
        method === 'POST' && id && !strict ? 'PUT' : method;
      requestConfig['data'] = params;
      log =
        requestConfig['method'] === 'POST'
          ? `Se ha añadido ${logMessages[endPoint]}`
          : `Se ha actualizado ${logMessages[endPoint]} con id ${id}`;
      break;
    case 'DELETE':
      requestConfig['params'] = isMultiParams ? multiParams : params;
      log = `Se ha eliminado ${logMessages[endPoint]} con id ${id}`;
      break;
    case 'FILEUPLOAD':
      requestConfig['method'] = 'POST';
      requestConfig['data'] = params;
      break;
  }
  return { requestConfig, log, token };
};

const axiosRequest = async (url, requestConfig) =>
  await axios(url, requestConfig);
const axiosRequestList = async (url, requestConfig) => {
  if (cancel !== undefined) cancel();
  return await axios(url, {
    ...requestConfig,
    cancelToken: new CancelToken((c) => {
      cancel = c;
    }),
  })
    .then((response) => response)
    .catch(async (error) => {
      if (axios.isCancel(error)) return;
      return error;
    });
};

export const serverRequest = async (
  endPoint,
  id = null,
  params = null,
  method = 'GET',
  strict = false,
  list = false,
  headers,
) => {
  const url = prepareUrl(endPoint, params?.extraUrl, id);
  delete params?.extraUrl;
  try {
    const { requestConfig, log, token } = await prepareRequestConfig(
      endPoint,
      params,
      id,
      method,
      strict,
      headers,
    );
    console.log(url, requestConfig);
    const res = list
      ? await axiosRequestList(url, requestConfig)
      : await axiosRequest(url, requestConfig);
    // if (log) await saveLog('logs', log, requestConfig['method'], token)
    return res?.data;
  } catch (error) {
    const uncontrolledErrors = [500, 404];
    if (uncontrolledErrors.includes(error?.response?.data?.statusCode)) {
      CToast({});
      return false;
    }

    let errorList = [];
    if (typeof error?.response?.data?.message === 'string') {
      errorList.push(error.response.data.message);
    } else {
      errorList = [...error.response.data.message];
    }

    console.log(errorList);
    return { hasErrors: true, errorList };
  }
};
